
angular.module('cesium.es.services', [
    // Services
    'cesium.es.http.services',
    'cesium.es.comment.services',
    'cesium.es.social.services',
    'cesium.es.settings.services',
    'cesium.es.crypto.services',
    'cesium.es.profile.services',
    'cesium.es.notification.services',
    'cesium.es.message.services',
    'cesium.es.modal.services',
    'cesium.es.blockchain.services',
    'cesium.es.registry.services',
    'cesium.es.group.services',
    'cesium.es.wallet.services',
    'cesium.es.invitation.services',
    'cesium.es.subscription.services',
    'cesium.es.wot.services',
    'cesium.es.tx.services',
    'cesium.es.geo.services',
    'cesium.es.document.services',
    'cesium.es.network.services',
    'cesium.es.like.services'
  ])
;
